import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { BASE_PATH_2_QUERY, BASE_PATH_3_QUERY } from '@glass/common/modules/pages/queryParams';

const useBuilderQuery = ({ [BASE_PATH_2_QUERY]: section, [BASE_PATH_3_QUERY]: step }) => {
  const { query } = useRouter();
  return useMemo(
    () => ({
      [BASE_PATH_2_QUERY]: section,
      [BASE_PATH_3_QUERY]: step,
      ...(query || {}),
    }),
    [query, step, section],
  );
};

export default useBuilderQuery;
